import { render, staticRenderFns } from "./henschke.vue?vue&type=template&id=486dc2b4&scoped=true"
import script from "./henschke.vue?vue&type=script&lang=js"
export * from "./henschke.vue?vue&type=script&lang=js"
import style0 from "./henschke.vue?vue&type=style&index=0&id=486dc2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486dc2b4",
  null
  
)

export default component.exports